import { T } from '@tolgee/react';
import React from 'react';
import styled from 'styled-components';

import AppreciateSvg from '../../../assets/icons/AppreciateSvg';
import { useMetrics } from '../../../hooks/useMetrics';
import { Button } from '../../_atoms/Button';
import BaseModal from '../BaseModal';

interface AuthenticationModalProps {
  visible: boolean;
  onSignIn: () => void;
  onSignUp: () => void;
  templateId?: string;
}

export const AuthenticationModal: React.FC<AuthenticationModalProps> = ({
  visible,
  onSignIn,
  onSignUp,
  templateId,
}) => {
  const metrics = useMetrics(true); // Allow unauthenticated tracking

  const handleSignUp = () => {
    // Track signup initiated from shared lesson
    if (templateId) {
      metrics.logEvent('Presentation.SignUp.FromSharedLink', {
        originalPresentationId: templateId,
      });
    }
    onSignUp();
  };

  const handleSignIn = () => {
    // Track sign in initiated from shared lesson
    if (templateId) {
      metrics.logEvent('Presentation.SignIn.FromSharedLink', {
        originalPresentationId: templateId,
      });
    }
    onSignIn();
  };
  return (
    <BaseModal hideCancel visible={visible} width="500px" centered>
      <ModalContent>
        <IconContainer>
          <span style={{ color: '#666' }}>
            <AppreciateSvg />
          </span>
        </IconContainer>
        <Title>
          <T
            keyName="Sign in to access this lesson"
            defaultValue="Sign in to access this lesson"
          />
        </Title>
        <Message>
          <T
            keyName="Please log in or create an account"
            defaultValue="Please log in or create an account"
          />
        </Message>
        <ButtonContainer>
          <Button type="ghost" onClick={handleSignIn} styles={{ marginRight: '12px' }}>
            <T keyName="Log in" defaultValue="Log in" />
          </Button>
          <Button type="primary" onClick={handleSignUp} styles={{ marginRight: '12px' }}>
            <T keyName="Sign up" defaultValue="Sign up" />
          </Button>
        </ButtonContainer>
      </ModalContent>
    </BaseModal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0;
`;

const IconContainer = styled.div`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
`;

const Message = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 30px;
  color: #666;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;
